


    <p-dialog showHeader="false" [(visible)]="display" [modal]="true" width="700" [baseZIndex]="10000"
              header="Buscador de Declaraciones Adicionales" (onShow)="showDialogMaximized(dialDetail)"
              #dialDetail>


        <div class="animated fadeIn">

            <div class="row pb-2">
                <div class="col-md-12">
                    <span class="label-dialog-cexveg">{{DescripcionCampania}}</span>
                    <br />
                </div>
            </div>            

            <!--GRID DATOS-->
            <div class="row">
                <div class="col-md-12">
                    <div class="label-msg-info m-1">
                        <i class="fa fa-info-circle fa-lg"></i> Haga doble click para seleccionar una Declaración Adicional
                    </div>
                    
                    <div class="card card-accent-success">
                        <div class="card-header-buscador">
                            <i class="fa fa-align-justify"></i> Resultado de la búsqueda
                        </div>

                        <!-- GRID ROW SELECTION MODE: DOBLE CLIC (SINGLE) -->
                        <div class="card-body">

                            <p-table #tableSearch autoLayout="true" [value]="resultDeclaracionAdicional?.ResultList" [columns]="cols"
                                     selectionMode="single" [(selection)]="selectedDeclaracionAdicional" dataKey="Id"
                                     [paginator]="true"
                                     [rows]="resultDeclaracionAdicional?.PageSize" [totalRecords]="resultDeclaracionAdicional?.TotalCount" [loading]="loading"
                                     [ngClass]="displayGridHidden(resultDeclaracionAdicional?.ResultList)"
                                     styleClass="table table-responsive-sm  table-sm">
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                                    <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" (click)="onSelect(rowData)" (dblclick)="onRowDblClick($event, rowData)">
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span>
                                                {{rowData[col.field]}}
                                            </span>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                            <div *ngIf="tableSearch?.totalRecords" class="p-2">Se han encontrado {{ tableSearch?.totalRecords  | number:'1.0-0':'es-ES' }} registros</div>
                            <div class="empty-grid" *ngIf="tableSearch?.totalRecords === 0">No se ha encontrado ningún registro</div>
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <p-footer>
            <button type="button" pButton (click)="acceptDialog()" [disabled]="noAccepted()" label="Aceptar" class="p-confirm-dialog-accept" icon="pi pi-check" title="Aceptar"></button>
            <button type="button" pButton (click)="cancelDialog()" label="Cancelar" class="p-confirm-dialog-reject" icon="pi pi-times" title="Cancelar"></button>
        </p-footer>

    </p-dialog>

